// src/redux/reducer/languageReducer.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// Thunk: Change user language
export const changeUserLanguage = createAsyncThunk(
  "user/changeLanguage",
  async (_, thunkAPI) => {
    try {
      // console.log("done")
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No access token found");
      // console.log(token)
      const response = await axios.put(
        `${BASE_URL}/myData/changeLanguage`,
        {},
        {
          headers: {
            token: token,
          },
        }
      );
      // console.log(response.data)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const languageSlice = createSlice({
  name: "language",
  initialState: {
    currentLanguage: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearLanguageError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeUserLanguage.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeUserLanguage.fulfilled, (state, action) => {
        state.currentLanguage = action.payload.language;
        state.loading = false;
      })
      .addCase(changeUserLanguage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to change language";
      });
  },
});

export const { clearLanguageError } = languageSlice.actions;
export default languageSlice.reducer;
